import * as moment from 'moment';
import { Validator } from '../Validator';

export default class NifExpirationService implements Validator {

  // tslint:disable-next-line no-any
  public getValidation(expirationDate: any, message: string = 'nifExpiration'): Promise<void> {
    return new Promise(
      (res, error) => {
        const limitDate = moment().add(1, 'months');
        if ((!expirationDate) || (expirationDate < limitDate)) {
          error(message);
        } else {
          res();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/validation/validators/NifExpiration.tsx